import { tns } from 'tiny-slider/src/tiny-slider';

class PostsMobileSlider {
    constructor(el, nav) {
        this.el = el;
        this.nav = nav;

        const slideCount = this.el ? this.el.children.length : 0;
        const isMobile = window.matchMedia('(max-width: 640px)').matches;

        if (!isMobile || slideCount < 2) {
            return null;
        }

        const wrapper = this.el.closest('.block-posts__mobile-slider');
        if (wrapper) {
            wrapper.removeAttribute('aria-hidden');
        }

        const shouldLoop = slideCount > 2;

        return tns({
            container: this.el,
            autoplay: shouldLoop,
            autoplayButtonOutput: false,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: false,
            speed: 400,
            controls: true,
            items: 1,
            loop: shouldLoop,
            nav: true,
            navPosition: "bottom",
            navContainer: this.nav
        });
    }
}

export default PostsMobileSlider;
